import { t } from 'i18next';
import { useState } from 'react';

const EventSelectionCart = ({ title, img, id, onClick, startDate, endDate, projectGuID, index }) => {
  const [selectedCard,  setSelectedCard] = useState(null);
  const handleClick = (e) => {
    const buttons = document.querySelectorAll('.selectbutton');

    // loop through buttons
    buttons.forEach((button) => {
      // if the current button is the clicked button
      if (button === e.target) {
        // toggle between "Select" and "Selected" text
        button.textContent = button.textContent === t('Select') ? t('Selected') : t('Select');

        // Check if the element with ID 'form-section' exists
        const formSection = document.getElementById('form-section');
        if (formSection) {
          // navigate to id form-section
          formSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          });
        }
      } else {
        // set all other buttons to "Select"
        button.textContent = t('Select');
      }
    });

    onClick(id);
  };

  return (
    <div
      key={id}
      className={` ${selectedCard === index ? "scale-105 bg-green-50 shadow-2xl" : 'shadow-md bg-gray-50'}   block w-72 px-3  mt-4  rounded-3xl dark:bg-gray-50 text-center`}
    >

      <h5 className=" px-4 py-3 text-xl tracking-wide  capitalize text-customgreen text-center">
          {`${title.slice(0, 15)}...` }
        </h5>


        <img src={`data:image/jpeg;base64,${img}`} className="w-full h-32 rounded-t-3xl" alt={title} />


      <div className="justify-center items-center text-center pt-0">
        <div className="row ">
        <div className="col-lg-6  flex justify-between w-full items-center space-x-2">
  <span className="my-3 text-sm  tracking-tight text-customgreen whitespace-nowrap">
    {t('Start Date')}
  </span>
  <span className="underline  border-gray-300 text-customgreen text-sm  whitespace-nowrap">
    {startDate}
  </span>
</div>
<div className="col-lg-6 flex w-full justify-between items-center space-x-2">
<span className=" text-sm text-customgreen tracking-tight  whitespace-nowrap">
                {t('End Date')}</span>
                <span className="underline  border-gray-300 text-customgreen  text-sm  whitespace-nowrap">
                {endDate}
              </span>

          </div>
        </div>
        <div className='py-6'>

        <button
          onClick={(e) => {
            handleClick(e);
            setSelectedCard(index);
          }}
          className="select-none selectbutton w-full text-white  bg-customgreen hover:bg-hovergreen  font-medium rounded-full text-sm px-8 py-2.5 text-center "
          type="button"
        >
          {t('Select')}
        </button>
        </div>
      </div>
    </div>
  );
};

export default EventSelectionCart;
